import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'fiscal_year_set',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_income_budget');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.width = '1000px';
        this.modalConfig.title = val.name || '查看';

        this.openModal();
      }
    },
  },
};
